// extracted by mini-css-extract-plugin
module.exports = {"CaregiverProfile":"caregiver-profile_CaregiverProfile__3KD_e","Avatar":"caregiver-profile_Avatar__2Zkwq"};